<template>
  <div>
    <div class="row">
      <div class="col-lg-9 col-md-12">
        <card class="shadow-lg">
          <div class="row content-add-btn padbtn">
            <button class="btn btn-secondary" @click="$router.go(-1);">
              <i class="fa fa-chevron-left"></i>
              Regresar
            </button>
          </div>
          <hr />
          <form v-if="canCreate() || canUpdate()" @submit.prevent="validateForm">
            <div class="row">
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Código *"
                v-model="demandform.code"
                :disabled="disabledField"
                v-validate="modelValidations.code"
                name="Código"
                :error="getError('Código')">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Nombre *"
                v-model="demandform.name"
                v-validate="modelValidations.name"
                name="nombre"
                :error="getError('nombre')">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <label>Fecha de Inicio Y Fecha de Terminación *</label><br>
                <el-date-picker
                  class="picker-demand"
                  :clearable="true"
                  v-model="rangeDate"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  start-placeholder="Fecha de Inicio"
                  end-placeholder="Fecha de Terminación"
                  align="center">
                </el-date-picker>
              </div>
              <!--<div class="col-md-6">
                <label>Fecha de Inicio *</label>
                <br>
                <el-date-picker
                  v-model="demandform.start_date"
                  type="date" >
                </el-date-picker>
              </div>
              <div class="col-md-6">
                <label>Fecha de Terminación *</label>
                <br>
                <el-date-picker
                  v-model="demandform.finish_date"
                  type="date" >
                </el-date-picker>
              </div>-->
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label>Descripción</label>
                <br />
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 8, maxRows: 8}"
                  v-model="demandform.description"
                  class="shadow-sm">
                  </el-input>
              </div>
              <div class="col-lg-6">
                <label>Anexos *</label>
                <el-upload multiple
                  class="upload-demo"
                  drag
                  ref="upload"
                  :data="demandform"
                  action="https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/demands"
                  :file-list="annexes"
                  :on-preview="handlePreview"
                  :on-change="handleSuccess"
                  :auto-upload="false">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Suelta tus documentos aquí o <em>haz clic para cargar</em>
                  </div>
                  <div slot="tip" class="el-upload__tip">Solo archivos <span style="color: #409eff;">.pdf / .excel / .word / .jpg / .png / .zip / .rar</span></div>
                </el-upload>
              </div>
            </div><br><hr><br>
            <div class="text-center">
              <button type="submit" class="btn btn-fill btn-warning btn-wd">
                Guardar
              </button>
            </div>
          </form>
          <div v-else>
            <div class="text-center">
              <h4> <strong> No tienes permiso para crear o editar </strong></h4>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import axios from 'axios'
  import moment from 'moment'
  import { Upload } from "element-ui";

  export default {
    components: {
      [Upload.name]: Upload,
    },
    data () {
      return {
        demandform: {
          code: null,
          name: null,
          description: null,
          start_date: null,
          finish_date: null,
        },
        rangeDate: [],
        annexes: [],
        modelValidations: {
          code: {
            required: true,
          },
          name: {
            required: true,
          },
          start_date: {
            required: true,
          },
          finish_date: {
            required: true,
          },
        },
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods:{
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            this.submitUpload();
          }
        })
      },

      handlePreview(file) {
        this.$emit('cotentLoading', true)
        if (file.status == 'success') {
          axios({
            url: file.url,
            method: "GET",
            responseType: "blob",
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", file.name);
            document.body.appendChild(link);
            link.click();
            this.$emit('cotentLoading')
          });
        } else {
          const url = window.URL.createObjectURL(new Blob([file.raw]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.name);
          document.body.appendChild(link);
          link.click();
          this.$emit('cotentLoading')
        }
      },

      handleSuccess(file, annexes) {
        if (localStorage.getItem('demandEdit')) {
          this.annexes.forEach(annex => {
            if (annex.name == file.raw.name) {
              this.$refs.upload.handleRemove(file)
              showSwalAlert('El archivo ' + file.raw.name + ' ya esta cargado en la lista de archivos.', 'warning')
              return false
            }
          })
        }

        const filesRaw = this.$refs.upload.uploadFiles.map(annexe => annexe.raw)
        let size = filesRaw.length - 1
        for (let index = 0; index < size; index++) {
          const element = filesRaw[index]
          if (element && element.name == file.raw.name) {
            this.$refs.upload.handleRemove(element)
            showSwalAlert('El archivo ' + file.raw.name + ' ya esta cargado en la lista de archivos.', 'warning')
            return false
          }
        }

        let types = [
          'image/jpeg',
          'image/png',
          'application/pdf',
          'application/msword',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/zip',
          'application/x-zip-compressed',
          'application/x-rar-compressed'
        ]

        if (!file.name.includes('.rar') && !types.includes(file.raw.type)) {
          console.log(file.raw.type)
          showSwalAlert('Lo sentimos, ha seleccionado un archivo no valido, la extensión debe ser .pdf / .excel / .word / .jpg / .png / .zip / .rar!', 'warning');
          this.$refs.upload.handleRemove(file)
          return false
        }

        return true
      },

      submitUpload() {
        let self = this;
        self.$emit('cotentLoading', true)
        const filesRaw = this.$refs.upload.uploadFiles.map((file) => file.raw)
        const bodyFormData = new FormData();
        let urlHttp;

        if (!localStorage.getItem("demandEdit")) {

          filesRaw.forEach((file) => bodyFormData.append("annexes[]", file, file.name))
          urlHttp = 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/demands'

        } else {

          let uids = this.annexes.map((file) => file.uid)
          filesRaw.forEach((file) => {
            if (file) {
              if (!uids.includes(file.uid)) {
                bodyFormData.append("new_annexes[]", file, file.name)
              }
            }
          })

          let new_uids = this.$refs.upload.uploadFiles.map((file) => file.uid)

          this.annexes.forEach((annex) => {
            if (!new_uids.includes(annex.uid)){
              bodyFormData.append("blurry_annexes[]", annex.name)
            }
          })

          urlHttp = 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/demands/'+this.demandform.id

        }

        bodyFormData.append('code', this.demandform.code)
        bodyFormData.append('name', this.demandform.name)
        bodyFormData.append('description', this.demandform.description)
        bodyFormData.append('start_date', moment(String(this.rangeDate[0])).format('YYYY-MM-DD'))
        bodyFormData.append('finish_date', moment(String(this.rangeDate[1])).format('YYYY-MM-DD'))

        axios({
          method: "post",
          url: urlHttp,
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + this.$store.state.auth.token,
          },
        }).then(function (response) {
          self.$emit('cotentLoading')
          showSwalAlert(response.data.message, "success").then(() =>
            self.$router.push("/demands")
          );
        }).catch((response) => self.showMessageErrors(error));
      },
    },
    created(){
      if(this.canCreate() || this.canUpdate()){
        if (localStorage.getItem('demandEdit')) {
          this.$emit('cotentLoading', true)
          setTimeout(() => {
            this.disabledField = true
            this.demandform = JSON.parse(localStorage.getItem('demandEdit'))
            this.rangeDate[0] = this.demandform.start_date
            this.rangeDate[1] = this.demandform.finish_date
            this.annexes = JSON.parse(this.demandform.files_list);
            this.$emit('cotentLoading')
          }, 1000);
        }
      }
    },
    beforeDestroy(){
      localStorage.removeItem('demandEdit');
    }
  }
</script>
<style>
.picker-demand {
  width: 100% !important;
}
</style>
